import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { UserInfoService } from '../core/auth/user-info/user-info.service';
import { ActivatedRoute, Router } from '@angular/router';
import { getCookieOptions } from '../core/auth/user-info/user-info.model';

@Component({
  selector: 'app-callback',
  template: `<app-load></app-load>`,
})
export class CallbackComponent implements OnInit {
  constructor(
    private cookieService: CookieService,
    private userInfoService: UserInfoService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const { session_id } = this.route.snapshot.queryParams;
    if (session_id) {
      this.cookieService.put('session_id', session_id, getCookieOptions());
    } else {
      this.cookieService.remove('session_id');
    }
    this.userInfoService.refreshUserInfo().subscribe({
      next: (userInfo) => {
        if (userInfo) {
          this.router.navigate(['/protected/dashboard']).catch(console.error);
        } else {
          this.router.navigate(['/login']).catch(console.error);
        }
      },
      error: () => {
        this.router.navigate(['/login']).catch(console.error);
      },
    });
  }
}
